import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/hotCity/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/hotCity/create', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/hotCity/delete/${id}`)
}
